module.exports = __webpack_public_path__ + "static/media/GoogleBigQuery.d31ee78f.png";